import paths from '../paths';

export { paths };
